$('.js-gallery-sl').slick({
  dots: true,
  infinite: true,
  speed: 300,
  slidesToShow: 1,
  arrows: true,
  nextArrow: '<button class="11 prev-gallery"></button>',
  prevArrow: '<button class="22 next-gallery"></button>'
})

$('.js-gallery-sl-new').slick({
  dots: true,
  infinite: true,
  speed: 300,
  slidesToShow: 1,
  arrows: true,
  nextArrow: '<button class="33 prev-gallery"></button>',
  prevArrow: '<button class="44 next-gallery"></button>'
})

$('.js-gallery-sl-end').slick({
  dots: true,
  infinite: true,
  speed: 300,
  slidesToShow: 1,
  arrows: true,
  nextArrow: '<button class="55 prev-gallery"></button>',
  prevArrow: '<button class="66 next-gallery"></button>'
})



// WEBPACK FOOTER //
// ./src/js/pages/one-route/sl-gallery.js